import { runStatusBadge, runStatusLabel, type RunStatusKey } from '../../lib/constants';

export function StatusBadge({ status }: { status: string }) {
  const key = status.toUpperCase() as RunStatusKey;
  const cls = runStatusBadge[key] ?? 'badge badge--neutral';
  const label = runStatusLabel[key] ?? status;
  return <span className={cls}>{label}</span>;
}
